export default "__VITE_ASSET__6f4a3388__"